<template>
  <h3 
    class="section-header josh-js"
    :class="{'section-header--invert': invert}"
    data-josh-anim-name="fadeIn"
    data-josh-duration="1500ms"
    data-josh-anim-delay="0.3s"
  >
    <slot />
  </h3>
</template>

<script>
  import Josh from 'joshjs';

  export default {
    name: 'SectionHeader',
    props: {
      invert: {
        type: Boolean
      }
    },
    mounted () {
      // eslint-disable-next-line
      const josh = new Josh();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .section-header {
    position: relative;
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 55px;
    text-align: center;
    color: var(--section-header-color);
    text-align: center;

    &--invert {
      color: #fff;
    }

    &:after {
      content: '';
      width: 40px;
      height: 2px;
      left: 50%;
      bottom: -15px;
      transform: translateX(-50%);
      position: absolute;
      background-color: #ffd800;
    }

    @include lgScreen() {
      font-size: 36px;
    }
  }
</style>
